import type { Agent as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Agent = {
  id?: number;
  agencyName?: string;
  email?: string;
  name?: string;
};

export const fromGql = (item: GQLItem): Agent =>
  take<Agent, GQLItem>(item, 'id', 'agencyName', 'email', 'name');
